import posthog from "posthog-js";
import TokenProvider from "../providers/TokenProvider";
import * as Roles from "../models/security/Roles";

export type IPostHog = typeof posthog;
export const updatePosthogUserInfo = (posthog: IPostHog) => {
    const isLoggedIn = TokenProvider.TokenExistsAndIsNotExpired();
    if (!isLoggedIn) {
        posthog.reset();
        return;
    }

    const token = TokenProvider.GetStoredTokenParsed();

    const userId = token?.nameid;
    const email = token?.sub;
    const roles = token?.roles || [];
    const isStaff = roles.indexOf(Roles.Administrator) > -1;

    posthog.identify(userId, { isStaff });
    posthog.people.set({ email });
};

const initializePostHog = () => {
    const POSTHOG_KEY = process.env.REACT_APP_POST_HOG_KEY;

    if (POSTHOG_KEY) {
        posthog.init(`${process.env.REACT_APP_POST_HOG_KEY}`, {
            api_host: "https://app.posthog.com",
            loaded: updatePosthogUserInfo,
            person_profiles: "identified_only" // Don't track anon users
        });
    } else {
        console.warn(
            "`REACT_APP_POST_HOG_KEY` not found in environment variables"
        );
    }
};

export default initializePostHog;
